import React from "react"
import { setIsEditingTextMode } from "../../store/slices/editor.slice"
import { useAppDispatch } from "../useRedux"

export const useEditingTextMode = () => {
    const dispatch = useAppDispatch()
    const clickTimeout = React.useRef<NodeJS.Timeout | null>(null)
    const setIsEditingMode = () => {
        if (clickTimeout.current) {
            clearTimeout(clickTimeout.current)
            clickTimeout.current = null
            dispatch(setIsEditingTextMode(true))
            return
        }

        clickTimeout.current = setTimeout(() => {
            clickTimeout.current = null
            dispatch(setIsEditingTextMode(false))
        }, 100)
    }
    return {
        setIsEditingMode,
    }
}
